import ClientStater from './clientStater';
import { MsgData } from './protobuf/msg';
import { LoginOutMsg } from './protobuf/loginout';
import { RequestMsg } from './protobuf/request';
import { PullRequest } from './protobuf/pullMsg';
//import { IFriendLastMsg, FriendLastMsg } from './protobuf/friendLast';
import { Constant } from './utils/constant';
import { ByteUtil, GuidUtil } from './utils/index';
import commonBiz from './domain/common/commonBiz';
import callEventBiz from './domain/call/callEventBiz';
import msgBiz from './domain/msg/msgBiz';
import { EventBus } from './domain/eventBus/eventBus';
import msgReadStatusBiz from './domain/msg/msgReadStatusBiz';
export default class IMSDK {
    isConnected() {
        return this.clientStater && this.clientStater.isConnected();
    }
    // 获取连接状态
    getConnectionState() {
        return this.clientStater ? this.clientStater.getConnectionState() : 'DISCONNECTED';
    }
    constructor(uri, opts) {
        this.clientStater = new ClientStater(uri, opts, {
            disconnectEvent: this.clearTime
        });
    }
    clearTime() {
        if (this.heartTimer) {
            clearTimeout(this.heartTimer);
        }
    }
    startTimerHeart(fromGuid) {
        commonBiz.sendHeart(this.clientStater, fromGuid).then((res) => {
            if (res.code === 200) {
                this.heartTimer = setTimeout(() => {
                    this.startTimerHeart(fromGuid);
                }, 15 * 1000);
            }
            else if (res.code === 502) {
                this.clientStater.disconnect();
                this.clearTime();
            }
        }).catch((e) => { console.log(e); })
    }
    // 登录
    login(token, fromGuid, role) {
        this.clearTime();
        return new Promise((resolve, reject) => {
            commonBiz.doLogin(this.clientStater, token, fromGuid, role)
                .then((res) => {
                    this.startTimerHeart(fromGuid);
                    resolve(res);
                }).catch(e => {
                    reject(e);
                });
        });
    }
    callUser(fromGuid, toGuid, houseGuid, totalGuids, version = 1) {
        this.clearTime();
        return new Promise((resolve, reject) => {
            callEventBiz.sendCallEvent(this.clientStater, fromGuid, toGuid, houseGuid, totalGuids, version)
                .then((res) => {
                    resolve(res);
                }).catch(e => {
                    reject(e);
                });
        });
    }
    callOpt(callGuid, fromOrClient, allowOrReject, toGuid) {
        this.clearTime();
        return new Promise((resolve, reject) => {
            callEventBiz.callCallEventOpt(this.clientStater, callGuid, fromOrClient, allowOrReject, toGuid)
                .then((res) => {
                    resolve(res);
                }).catch(e => {
                    reject(e);
                });
        });
    }
    newGuid() {
        return new Promise((reslove, reject) => {
            commonBiz.doGuidRquest(this.clientStater).then(res => {
                reslove(res.msg);
            }).catch((e) => {
                reject(e);
            });
        });
    }
    sendTextMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.TEXT, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendImageMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.IMAGE, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendAccMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.ACC, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendHouseMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.HOUSE, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendCardMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.CARD, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendCardTextMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.CARDTEXT, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendArticleMsg(msgGuid, fromGuid, targetGuid, msg, sender) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.ARTICLE, sender, null).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendActionMsg(msgGuid, fromGuid, targetGuid, msg, sender, extension) {
        return new Promise((reslove, reject) => {
            msgBiz.sendP2PMsg(this.clientStater, msgGuid, fromGuid, targetGuid, msg, MsgData.ContentType.ACTIONS, sender, extension).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    sendCallEventOpt(callGuid, fromOrClient, allOrReject, toGuid) {
        return new Promise((reslove, reject) => {
            callEventBiz.callCallEventOpt(this.clientStater, callGuid, fromOrClient, allOrReject, toGuid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    // sendMsg().then(res)=>{
    //     res.guid
    // res.action.then()=> {
    // }
    // }
    // 退出
    async loginout(fromGuid, role) {
        let loginOutRole = '';
        if (role == '0') { //AGENT
            loginOutRole = LoginOutMsg.Role.AGENT;
        }
        else if (role == '1') { //CUSTOMER
            loginOutRole = LoginOutMsg.Role.CUSTOMER;
        }
        var _loginOut = {
            version: 1,
            fromGuid: fromGuid,
            role: loginOutRole
        };
        //编码
        let utf8 = LoginOutMsg.encode(_loginOut).finish();
        let sendByte = ByteUtil.unionUint8Array([
            ByteUtil.intArrToBytes([utf8.length, Constant.SendType.LOGINOUT]),
            utf8
        ]);
        //发送
        this.clearTime();
        this.clientStater.send(sendByte);
    }
    // 最后一条消息
    async pullLastMsg(fromGuid, friends) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _pullLastMsg = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                requestType: RequestMsg.RequestType.PULL_LASTMSG,
                friends: friends
            };
            //编码
            let utf8 = RequestMsg.encode(_pullLastMsg).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.REQUEST]),
                utf8
            ]);
            // 返回数据
            commonBiz.doPullLastMsg(this.clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    // 清空未读
    async clearUnread(fromGuid, friends) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _clearUnread = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                requestType: RequestMsg.RequestType.CLEAR_UNREAD,
                friends: friends
            };
            //编码
            let utf8 = RequestMsg.encode(_clearUnread).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.REQUEST]),
                utf8
            ]);
            // 返回数据
            commonBiz.msgOperate(this.clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    // 获取未读
    async getUnread(fromGuid, friends) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _unread = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                requestType: RequestMsg.RequestType.UNREAD,
                friends: friends
            };
            //编码
            let utf8 = RequestMsg.encode(_unread).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.REQUEST]),
                utf8
            ]);
            // 返回数据
            commonBiz.msgOperate(this.clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    //拉取未读数大于0的好友的guid，以用来同步本地好友列表
    async syncFriends(fromGuid) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _unread = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                requestType: RequestMsg.RequestType.SYNC_FRIENDS
            };
            //编码
            let utf8 = RequestMsg.encode(_unread).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.REQUEST]),
                utf8
            ]);
            // 返回数据
            commonBiz.msgOperate(this.clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    // 获取离线消息
    async getOfflineMsg(fromGuid, targetGuid) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _historyMsg = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                targetGuid: targetGuid,
                pullType: PullRequest.PullType.OFFLINE
            };
            //编码
            let utf8 = PullRequest.encode(_historyMsg).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.PULL]),
                utf8
            ]);
            // 返回数据
            return commonBiz.pullResponseOperate(this.clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    // 获取历史消息
    async getHistoryMsg(fromGuid, targetGuid, lastMsgGuid) {
        return new Promise((reslove, reject) => {
            let _guid = GuidUtil.nextId();
            var _historyMsg = {
                // 协议参数
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                targetGuid: targetGuid,
                lastMsgGuid: lastMsgGuid,
                // pageSize:pageSize,
                // page:page,
                pullType: PullRequest.PullType.HISTORY
            };
            //编码
            let utf8 = PullRequest.encode(_historyMsg).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.PULL]),
                utf8
            ]);
            // 返回数据
            return commonBiz.pullResponseOperate(this.clientStater, sendByte, _guid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    // 新增一个带分页的方法（可选参数）
    async getHistoryMsgWithPage(fromGuid, targetGuid, lastMsgGuid, page = 1, pageSize = 20) {
        return new Promise((resolve, reject) => {
            let _guid = GuidUtil.nextId();
            var _historyMsg = {
                guid: _guid,
                version: 1,
                fromGuid: fromGuid,
                targetGuid: targetGuid,
                lastMsgGuid: lastMsgGuid,
                page: page,
                pageSize: pageSize,
                pullType: PullRequest.PullType.HISTORY
            };

            let utf8 = PullRequest.encode(_historyMsg).finish();
            let sendByte = ByteUtil.unionUint8Array([
                ByteUtil.intArrToBytes([utf8.length, Constant.SendType.PULL]),
                utf8
            ]);

            return commonBiz.pullResponseOperate(this.clientStater, sendByte, _guid)
                .then(res => resolve(res))
                .catch(error => reject(error));
        });
    }
    //发送已读回执
    /**
     *
     * @param fromGuid 回执消息是谁发送的
     * @param targetGuid 发送给目标用户
     * @param startMsgGuid 开始的消息guid
     * @param endMsgGuid 结束的消息的guid
     * @returns
     */
    sendMsgReadStatus(fromGuid, targetGuid, startMsgGuid, endMsgGuid) {
        return new Promise((reslove, reject) => {
            msgReadStatusBiz.sendMsgReadStatus(this.clientStater, fromGuid, targetGuid, startMsgGuid, endMsgGuid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    //拉取离线消息已读回执
    /**
     *
     * @param fromGuid 要拉取的回执是 发给谁 的--是本人自己
     * @param targetGuid 要拉取的回执是 谁发 的--是好友
     * @returns
     */
    pullReadStatusMsg(fromGuid, targetGuid) {
        return new Promise((reslove, reject) => {
            msgReadStatusBiz.pullReadStatusMsg(this.clientStater, fromGuid, targetGuid).then(res => {
                reslove(res);
            }).catch(error => {
                reject(error);
            });
        });
    }
    async dispose() {
        this.clearTime();
        EventBus.clear();
    }
}
//# sourceMappingURL=IMSDK.js.map
